import { isEmpty } from 'lodash';
import { Badge } from 'react-bootstrap';
import { ActionEnum } from '../../../api';
import { StatusColor } from './utils';

interface BookingChange {
  id: string;
  start_on: string;
  end_on?: string;
  start_time: string;
  end_time: string;
  is_overtime: boolean;
  is_added: boolean;
  is_removed: boolean;
  is_changed: boolean;
  previous?: {
    start_on: string;
    end_on?: string;
    start_time: string;
    end_time: string;
  };
  status_by_provider?: {
    from_value: string;
    to_value: string;
  };
  status_by_rep?: {
    from_value: string;
    to_value: string;
  };
}

interface BookingHistoryItemProps {
  booking: BookingChange;
}

export const BookingHistoryItem = ({ booking }: BookingHistoryItemProps) => {
  const renderTimeDisplay = (
    startOn: string,
    endOn: string | undefined,
    startTime: string,
    endTime: string,
    isStrikethrough?: boolean
  ) => {
    const className = isStrikethrough ? 'text-decoration-line-through' : '';
    if (endOn) {
      return (
        <>
          <span className={`fw-semibold text-color-primary-dark ${className}`}>
            {startOn} {startTime.substring(0, 5)}
          </span>
          <span className={`text-muted ${className}`}> to </span>
          <span className={`fw-semibold text-color-primary-dark ${className}`}>
            {endOn} {endTime.substring(0, 5)}
          </span>
        </>
      );
    }
    return (
      <>
        <span className={`fw-semibold text-color-primary-dark ${className}`}>{startOn}</span>
        <span className="text-muted"> (</span>
        <span className={`fw-semibold text-color-primary-dark ${className}`}>
          {startTime.substring(0, 5)} - {endTime.substring(0, 5)}
        </span>
        <span className="text-muted">) </span>
      </>
    );
  };

  if (booking.is_added) {
    return (
      <li>
        {renderTimeDisplay(booking.start_on, booking.end_on, booking.start_time, booking.end_time)}{' '}
        {booking.is_overtime ? (
          <Badge className="ms-2 bg-info fw-semibold">Overtime</Badge>
        ) : (
          <Badge className="ms-2 bg-success fw-semibold">Added</Badge>
        )}
      </li>
    );
  }

  if (booking.is_changed && booking.previous) {
    return (
      <li>
        {renderTimeDisplay(
          booking.previous.start_on,
          booking.previous.end_on,
          booking.previous.start_time,
          booking.previous.end_time,
          true
        )}{' '}
        {renderTimeDisplay(booking.start_on, booking.end_on, booking.start_time, booking.end_time)}{' '}
        <Badge className="ms-2 bg-warning fw-semibold">Changed</Badge>
      </li>
    );
  }

  if (booking.is_removed) {
    return (
      <li>
        {renderTimeDisplay(booking.start_on, booking.end_on, booking.start_time, booking.end_time)}{' '}
        <Badge className="ms-2 bg-danger fw-semibold">Removed</Badge>
      </li>
    );
  }

  if (!isEmpty(booking.status_by_provider)) {
    return (
      <li>
        {renderTimeDisplay(booking.start_on, booking.end_on, booking.start_time, booking.end_time)}{' '}
        <span className="text-muted">from </span>
        <span className={StatusColor[booking.status_by_provider.from_value]}>
          {booking.status_by_provider.from_value}
        </span>{' '}
        <span className="text-muted">to </span>
        <span className={StatusColor[booking.status_by_provider.to_value]}>
          {booking.status_by_provider.to_value}
        </span>
      </li>
    );
  }

  if (!isEmpty(booking.status_by_rep)) {
    return (
      <li>
        {renderTimeDisplay(booking.start_on, booking.end_on, booking.start_time, booking.end_time)}{' '}
        <span className="text-muted">from </span>
        <span className={StatusColor[booking.status_by_rep.from_value]}>
          {booking.status_by_rep.from_value}
        </span>{' '}
        <span className="text-muted">to </span>
        <span className={StatusColor[booking.status_by_rep.to_value]}>
          {booking.status_by_rep.to_value}
        </span>
      </li>
    );
  }

  return null;
};

// Optional: Export a list component that handles multiple booking items
// interface BookingHistoryListProps {
//   bookings: BookingChange[];
//   StatusColor: Record<string, string>;
//   action: ActionEnum;
// }

// export const BookingHistoryList = ({ bookings, action, StatusColor }: BookingHistoryListProps) => {
//   if (!bookings || bookings.length === 0) {
//     return null;
//   }

//   return (
//     <div className="booking-history-list">
//       {bookings.map((booking) => (
//         <BookingHistoryItem
//           key={booking.id}
//           booking={booking}
//           action={action}
//           StatusColor={StatusColor}
//         />
//       ))}
//     </div>
//   );
// };
